import { Select } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from '../../i18n/i18n';
import './SectionPicker.scss';

const iconVar = (name) => ({ '--icon': `url(/icons/${name}.svg)` });

/** The rule NavLink applies, so a picker never disagrees with a nav beside it. */
const isCurrent = (section, pathname) =>
  section.end
    ? pathname === section.to
    : pathname === section.to || pathname.startsWith(`${section.to}/`);

/**
 * The section switcher a feature shows on a phone, where its own nav — the
 * Affiliate aside, the sidebar's Payout sub-nav — has nowhere to live.
 *
 * antd rather than a bare `select` because the option list carries the section
 * icons and the Style Guide's chrome, which a native listbox can't be told to
 * do. Same reason Button and SegmentedTabs are antd, styled locally.
 *
 * `sections` are `{ to, label, icon, end? }`, the same shape the nav lists use,
 * so a feature can pass the array it already has.
 */
export default function SectionPicker({ sections, label, className = '' }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const current = sections.find((section) => isCurrent(section, pathname)) ?? sections[0];

  return (
    <Select
      className={`section-picker ${className}`.trim()}
      popupClassName="section-picker-popup"
      variant="borderless"
      value={current.to}
      onChange={(to) => navigate(to)}
      options={sections.map((section) => ({
        value: section.to,
        label: (
          <span className="section-picker__option">
            <span className="icon section-picker__icon" style={iconVar(section.icon)} />
            <span className="section-picker__label">{t(section.label)}</span>
          </span>
        ),
      }))}
      suffixIcon={<span className="icon section-picker__caret" style={iconVar('chevron-down')} />}
      aria-label={t(label)}
    />
  );
}
